// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pt-1";
export var stateContainer = "_pt-0";